import React from 'react';
import { Link } from 'react-router-dom';
import { getEmailFromStorage } from '../../utils/helpers/storageUtils';

const NotFound = () => (
  
  <div className='notfound' >
    <h1 style={{fontSize: 77}}>404</h1>
    <h4 className='mt-2 mb-4'>Sorry, we couldn't find that page.</h4>
    {!(getEmailFromStorage()) && <Link to="/login"><button className='btn btn-primary'>GO TO LOGIN</button></Link>}
    {(getEmailFromStorage()) && <Link to="/home"><button className='btn btn-primary'>GO TO HOME</button></Link>}
  </div>
);

export default NotFound;